import { css } from '@emotion/react';
import { theme } from 'global';

export const h4 = css`
  margin: 0 0 24px;
`;

export const formControl = css`
  width: 100%;
`;

export const radioGroup = css`
  margin-top: 0;
`;

export const radioButtonGrid = css`
  display: flex;
`;

export const radioButton = (selected) => css`
  border: 2px solid
    ${selected ? theme.colors.primary.medium : `rgb(221, 221, 227)`};
  border-radius: ${theme.radii.md};
  padding: 0px 16px;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  > span {
    color: ${theme.colors.body} !important;
    flex-direction: column;
    display: flex;
    align-items: center;
  }
`;

export const radioButtonFullWidth = (selected) => css`
  border: 1px solid
    ${selected ? theme.colors.primary.medium : theme.colors.neutral[200]};
  border-radius: ${theme.radii.lg};
  padding: 12px;
  justify-content: flex-start;
  align-items: center;
  min-height: 48px;
  width: 100%;
  background: ${selected ? theme.colors.primary.lightest : theme.colors.white};
  gap: 12px;
  margin-left: 0;
  margin-right: 0;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    border-color: ${selected
      ? theme.colors.primary.medium
      : theme.colors.neutral[200]};
    background: ${selected
      ? theme.colors.primary.lightest
      : theme.colors.neutral[0]};
  }

  /* Constrain the radio wrapper span to exactly 24px so gap is pure 12px */
  > span:first-of-type {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .MuiRadio-root {
    padding: 0;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  .MuiRadio-root svg {
    width: 24px;
    height: 24px;
  }

  .MuiRadio-root:not(.Mui-checked) svg {
    color: ${theme.colors.neutral[300]};
  }

  .MuiFormControlLabel-label {
    margin-left: 0 !important;
    color: ${theme.colors.neutral[600]};
  }
`;

export const customIcon = css`
  font-size: inherit;
  padding: 24px 8px;

  &:hover,
  > .Mui-checked:hover {
    background-color: transparent !important;
  }

  > .MuiIconButton-label {
    flex-direction: column;
`;
